var prodcat = prodcat || {};
var site = site || {};
var generic = generic || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

(function ($) {
  Drupal.behaviors.productSocialV1 = {
    isMobile: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['usn-medium'], 10);

      return currentBpWidth <= bPlargeUp;
    },
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var self = this;
      var $product = $('.js-product-full', context);
      var $productSocialWrapper = $('.js-product-social-share', $product);
      var $productSocialShareTrigger = $('.js-product-social-trigger', $productSocialWrapper);
      var $productFullSocialLinks = $('.js-product_social_links', $productSocialWrapper);

      if ($productSocialWrapper.length <= 0) {
        return;
      }

      $productSocialWrapper.on('focusin mouseover', function () {
        $productFullSocialLinks.addClass('share_show');
      });
      $productSocialWrapper.on('mouseout', function () {
        $productFullSocialLinks.removeClass('share_show');
      });
      $productSocialShareTrigger.on('click', function (e) {
        if (self.isMobile()) {
          e.preventDefault();
          $productFullSocialLinks.toggle();
        }
      });
      self.emailSocialShareLink();
      self.twitterSocialShareLink();
      self.facebookSocialShareLink();
      self.pinterestSocialShareLink();
    },
    productRecordSocialAction: function (platform) {
      var loyaltySocialEarning = Drupal.settings.globals_variables.loyalty_social_earning || '';

      if (Array.isArray(loyaltySocialEarning) && loyaltySocialEarning.length) {
        if (loyaltySocialEarning.includes(platform)) {
          generic.jsonrpc.fetch({
            'method': 'user.recordSocialAction',
            'params': [
              {
                action: 'share',
                url: window.location.href,
                platform: platform
              }
            ]
          });
        }
      }
    },
    emailSocialShareLink: function (context) {
      var $product = $('.js-product-full', context);
      var $productSocialWrapper = $('.js-product-social-share', $product);
      var $productFullSocialLinks = $('.js-product_social_links', $productSocialWrapper);
      var $emailSocialLink = $('.js-product-social-link-email', $productFullSocialLinks);
      var prodID = $productSocialWrapper.data('product-id');
      var product = prodcat.data.getProduct(prodID);
      var emailSubject = encodeURIComponent(product.PROD_RGN_NAME);
      var emailBody = encodeURIComponent(window.location.href);
      var emailFullUrl = 'mailto:?subject=' + emailSubject + '&body=' + emailBody;

      $emailSocialLink.on('click', function () {
        window.location.href = emailFullUrl;
      });
    },
    twitterSocialShareLink: function (context) {
      var self = this;
      var $product = $('.js-product-full', context);
      var $productSocialWrapper = $('.js-product-social-share', $product);
      var $productFullSocialLinks = $('.js-product_social_links', $productSocialWrapper);
      var $twitterSocialLink = $('.js-product-social-link-twitter', $productFullSocialLinks);
      var prodID = $productSocialWrapper.data('product-id');
      var product = prodcat.data.getProduct(prodID);
      var siteName = site.translations.product.mac_comsmetics_name;
      var officialSite = site.translations.product.official_site;
      var twitterTitle = encodeURIComponent(product.PROD_RGN_NAME) + ' %7C ' + siteName + ' %7C ' + encodeURIComponent(officialSite);
      var twitterUrl = encodeURIComponent(window.location.href);
      var twitterFullUrl = 'https://twitter.com/share/?text=' + twitterTitle + '&url=' + twitterUrl;

      $twitterSocialLink.on('click', function () {
        window.open(twitterFullUrl, 'tweet', 'width=790,height=460');
        self.productRecordSocialAction('twitter');
      });
    },
    facebookSocialShareLink: function (context) {
      var self = this;
      var $product = $('.js-product-full', context);
      var $productSocialWrapper = $('.js-product-social-share', $product);
      var $productFullSocialLinks = $('.js-product_social_links', $productSocialWrapper);
      var $facebookSocialLink = $('.js-product-social-link-facebook', $productFullSocialLinks);
      var prodID = $productSocialWrapper.data('product-id');
      var product = prodcat.data.getProduct(prodID);
      var siteName = site.translations.product.mac_comsmetics_name;
      var officialSite = site.translations.product.official_site;
      var facebookTitle = encodeURIComponent(product.PROD_RGN_NAME) + ' %7C ' + siteName + ' %7C ' + officialSite;
      var facebookUrl = encodeURIComponent(window.location.href);
      var facebookFullUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + facebookUrl + '&t=' + facebookTitle;

      $facebookSocialLink.on('click', function () {
        window.open(facebookFullUrl, 'facebook_share', 'width=790,height=460');
        self.productRecordSocialAction('facebook');
      });
    },
    pinterestSocialShareLink: function (context) {
      var self = this;
      var $product = $('.js-product-full', context);
      var $productSocialWrapper = $('.js-product-social-share', $product);
      var $productFullSocialLinks = $('.js-product_social_links', $productSocialWrapper);
      var $pinterestSocialLink = $('.js-product-social-link-pinterest', $productFullSocialLinks);
      var prodID = $productSocialWrapper.data('product-id');
      var product = prodcat.data.getProduct(prodID);
      var siteName = site.translations.product.mac_comsmetics_name;

      $pinterestSocialLink.on('click', function () {
        var skuBaseId = $productSocialWrapper.data('sku-base-id');
        var pinterestFullUrl = pinterestFullLink(skuBaseId);

        window.open(pinterestFullUrl, 'pinterest', 'width=790,height=460');
        self.productRecordSocialAction('pinterest');
      });

      function pinterestFullLink(skuBaseId) {
        var skuData = prodcat.data.getSku(skuBaseId);
        var productImageSrc = $('.js-product-image', $product).attr('src');
        var pinterestUrl = encodeURIComponent(window.location.href);
        var pinterestMedia = encodeURIComponent(window.location.origin + productImageSrc);
        var pinterestDescription = siteName + encodeURIComponent(': ' + product.PROD_RGN_NAME + ' in ' + skuData.SHADENAME);
        var pinterestFullUrl = 'https://www.pinterest.com/pin/create/button/?url=' + pinterestUrl + '&media=' + pinterestMedia + '&description=' + pinterestDescription;

        return pinterestFullUrl;
      }
    },
    attached: false
  };
  $(document).on('product.skuSelect', '.js-product-ui', function (e, skuBaseId) {
    var $product = $(this);
    var $productSocialWrapper = $('.js-product-social-share', $product);

    $productSocialWrapper.data('sku-base-id', skuBaseId);
  });
})(jQuery);
